import createReducer from "Common/reducerUtils/createReducer";
import set from "Common/reducerUtils/set";
import size from "lodash/size";
import { NAMESPACE, NEW_WORKSPACE } from "../constants";
import actionTypes from "./actionTypes";
export const initialState = {
    [NAMESPACE]: { draft: {}, data: undefined, workSpaceId: undefined }
};
export default createReducer(initialState, {
    [actionTypes.SET_DRAFT]: (state, { draft }) => {
        const isDraftPartial = size(draft) === 1;
        return set(state, `[${NAMESPACE}].draft`, isDraftPartial && draft ? { ...state[NAMESPACE].draft, ...draft } : draft, {
            checkExistence: false,
            checkEqual: false
        });
    },
    [actionTypes.GET_WORK_SPACE_COMPLETED]: (state, { payload }) => set(state, `[${NAMESPACE}].data`, payload),
    [actionTypes.SET_WORK_SPACE_ID]: (state, { workSpaceId }) => ({
        ...state,
        [NAMESPACE]: {
            ...state[NAMESPACE],
            workSpaceId,
            data: workSpaceId === undefined ? undefined : state[NAMESPACE].data,
            draft: workSpaceId === undefined ? {} : state[NAMESPACE].draft
        }
    }),
    [actionTypes.SET_NEW_WORK_SPACE]: (state) => ({
        ...state,
        [NAMESPACE]: {
            ...state[NAMESPACE],
            workSpaceId: NEW_WORKSPACE.Id,
            data: { ...NEW_WORKSPACE },
            draft: {}
        }
    })
});
